export default __webpack_public_path__ + "static/media/helpingHands.d0ab0f35.jpg";